import { render, staticRenderFns } from "./addDemand.vue?vue&type=template&id=1af819a5&scoped=true"
import script from "./addDemand.vue?vue&type=script&lang=js"
export * from "./addDemand.vue?vue&type=script&lang=js"
import style0 from "./addDemand.vue?vue&type=style&index=0&id=1af819a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af819a5",
  null
  
)

export default component.exports